export default function (value) {
  if (!value) {
    return false
  }
  return Object.prototype.toString.call(value) === '[object Array]'
}



// WEBPACK FOOTER //
// ./~/vux/src/libs/is-array.js